import React from 'react'
import Img from 'gatsby-image'

import styles from './hero.module.scss'

export default ({ data, title }) => (
  <div
    className={`${styles.hero} divider-up `}
    style={{ marginTop: '-4.5rem' }}
  >
    <div className={styles.heroTitleOverlay}>
      <div className={styles.heroTextWrap}>
        <h1 className={`${styles.heroTitle} heading h1`}>{title}</h1>
        <p className={`${styles.heroTitle} heading heading--normal h4`}>
          West Wales' best gymnastics club for members of all ages
        </p>
      </div>
    </div>
    <Img className={styles.heroImage} fluid={data.node.fluid} />
  </div>
)
